<template>
  <div class="history-page">
    <block-buttons
      title="История действий на сайте"
      description="Просмотр истории действий"
      :actions="toolbarActions"
    >
      <template #icon>
        <GalleryVerticalEnd :size="22" />
      </template>
    </block-buttons>

    <data-table
      :rows="renderData"
      :columns="tableColumns"
      :loading="loading"
      :error="error"
      title="История"
      description="Просмотр истории действий"
      search-placeholder="Поиск по истории"
      empty-text="История пуста"
      @retry="loadDataWrapper(true)"
    >
      <template #cell-actions="{ row }">
        <select
          :disabled="loading"
          :aria-label="`Действия с историей ${row.title}`"
          @change="selectAction($event, row)"
        >
          <option value="">Действия</option>

          <option
            v-for="action in rowActions"
            :key="action.id"
            :value="action.id"
          >
            {{ action.label }}
          </option>
        </select>
      </template>
    </data-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import {
  GalleryVerticalEnd,
  RefreshCw
} from 'lucide-vue'

import BlockButtons from '@/components/blockButtons'
import DataTable from '@/components/dataTable'

export default {
  name: 'HistoryV2',
  components: {
    GalleryVerticalEnd,
    BlockButtons,
    DataTable
  },
  data () {
    return {
      loading: false,
      error: ''
    }
  },
  computed: {
    ...mapGetters('history', ['getData']),
    ...mapGetters('settings', ['getTableColumns', 'getDefaultValues']),
    renderData () {
      return this.getData.map(order => ({
        ...order,
        status: this.getDefaultValues?.['history']?.find(({ code }) => code === order.status)?.name || order.status || '—'
      }))
    },
    toolbarActions () {
      return  [
        {
          id: 'refresh',
          label: 'Обновить',
          icon: RefreshCw,
          disabled: this.loading,
          handler: this.loadDataWrapper
        }
      ]
    },
    tableColumns () {
      return [
        {
          key: 'actions',
          label: 'Действия',
          sortable: false
        },
        ...(this.getTableColumns?.['history'] || [])
      ]
    },
    rowActions () {
      return [
        {
          id: 'info',
          label: 'Информация',
          visible: true
        }
      ]
    }
  },
  mounted () {
    this.loadDataWrapper()
  },
  methods: {
    ...mapActions('history', ['loadData']),
    ...mapActions('modal', ['openModal']),
    async loadDataWrapper () {
      if (this.loading) {
        return
      }

      this.$bus.emit('start-loader')
      this.loading = true

      await this.loadData()

      this.loading = false
      this.$bus.emit('stop-loader')
    },
    selectAction (event, row) {
      const action = event.target.value

      event.target.value = ''

      if (!action) {
        return
      }

      this.openAction(action, row)
    },
    openAction (action, row) {
      switch (action) {
        case 'info':
          this.openModal({
            name: 'info-base',
            propsData: {
              name: 'history',
              moduleAction: 'history',
              type: 'info',
              title: `Информация об операции - ${row.type}`,
              textCancelBtn: 'Закрыть',
              data: row
            }
          })
      }
    }
  }
}
</script>

<style scoped lang="scss" src="./style.scss" />
